module.exports = __webpack_public_path__ + "static/media/map-usa.0fe5c925.png";